import { useMutation } from 'react-query'
import { INotification } from '../generated-types/notification'
import { queryClient } from '../query-client'
import { useGet } from './reactQuery'
import { requestProvider } from './requestProvider'

const baseUrl = (customerId: EntityId) => `customers/${customerId}/notifications`

export const notificationEndpoints = {
  unread: (customerId: EntityId) => `${baseUrl(customerId)}/unread`,
  unreadCount: (customerId: EntityId) => `${baseUrl(customerId)}/unread-count`,
  markAsRead: (customerId: EntityId, id: EntityId) => `${baseUrl(customerId)}/${id}/read`,
  markAllAsRead: (customerId: EntityId) => `${baseUrl(customerId)}/read-all`,
}

export const invalidateNotificationCache = (customerId: EntityId) => {
  queryClient.invalidateQueries([notificationEndpoints.unread(customerId)])
  queryClient.invalidateQueries([notificationEndpoints.unreadCount(customerId)])
}

export const useGetUnreadNotifications = (customerId: EntityId) =>
  useGet<INotification[]>(notificationEndpoints.unread(customerId), undefined, {
    enabled: !!customerId,
    refetchInterval: 60000,
    refetchOnWindowFocus: true,
  })

export const useGetUnreadNotificationCount = (customerId: EntityId) =>
  useGet<number>(notificationEndpoints.unreadCount(customerId), undefined, {
    enabled: !!customerId,
    refetchInterval: 60000,
    refetchOnWindowFocus: true,
  })

export const useMarkNotificationAsRead = (customerId: EntityId) =>
  useMutation((id: EntityId) => requestProvider.put(notificationEndpoints.markAsRead(customerId, id), {}), {
    onSuccess: () => invalidateNotificationCache(customerId),
  })

export const useMarkAllNotificationsAsRead = (customerId: EntityId) =>
  useMutation(() => requestProvider.put(notificationEndpoints.markAllAsRead(customerId), {}), {
    onSuccess: () => invalidateNotificationCache(customerId),
  })
